import {Box, Tabs, Tab} from '@mui/material'
import {useState, useEffect} from 'react'
import Sessions, {SessionItemData} from './Sessions'
import CreateNewChatButton from '../timeline/buttons/CreateNewChatButton'
import {useTranslation} from 'react-i18next'

interface SessionsSidebarProps {
  activeSessions: SessionItemData[]
  demandSessions: SessionItemData[]
  selectedSession: SessionItemData
  onStartSession: () => void
  onSelectSession: (item: SessionItemData) => void
  onDeleteSession?: (item: SessionItemData) => void
}

function TabPanel(props: {
  children: React.ReactNode
  value: number
  index: number
}) {
  const {children, value, index, ...other} = props
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  )
}

const SessionsSidebar = ({
  activeSessions,
  demandSessions,
  selectedSession,
  onStartSession,
  onSelectSession,
  onDeleteSession
}: SessionsSidebarProps) => {
  const [t] = useTranslation()

  const [tabValue, setTabValue] = useState<number>(() => {
    if (selectedSession) {
      const isInDemands = demandSessions.some(
        (s) => s.id === selectedSession.id
      )
      return isInDemands ? 1 : 0
    }
    return 0
  })

  useEffect(() => {
    if (!selectedSession) {
      setTabValue(0)
      return
    }
    if (demandSessions.some((s) => s.id === selectedSession.id)) {
      setTabValue(1)
    } else {
      setTabValue(0)
    }
  }, [selectedSession, demandSessions, activeSessions])

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue)
  }

  return (
    <Box width="280px" display="flex" flexDirection="column" paddingBottom={2}>
      <CreateNewChatButton onClick={onStartSession} />
      <Tabs
        centered
        value={tabValue}
        onChange={handleTabChange}
        aria-label="sessions-tabs"
        sx={{marginY: 2}}
      >
        <Tab label={t('fnd-assistant-sessions-tab-active')} />
        <Tab label={t('fnd-assistant-sessions-tab-demands')} />
      </Tabs>
      <Box
        flex={1}
        sx={{
          overflowY: 'auto',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          '&::-webkit-scrollbar': {
            display: 'none'
          }
        }}
      >
        <TabPanel value={tabValue} index={0}>
          <Sessions
            sessions={activeSessions}
            selectedSession={selectedSession}
            onSelectSession={(session) => onSelectSession(session)}
            onDeleteSession={onDeleteSession}
          />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <Sessions
            sessions={demandSessions}
            selectedSession={selectedSession}
            onSelectSession={(session) => onSelectSession(session)}
          />
        </TabPanel>
      </Box>
    </Box>
  )
}

export default SessionsSidebar
